import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "onCalculateContents", "onPageChange", "title", "totalCount", "isLoadingPageOnDemand", "page", "limit"];
import { Children, Fragment, useEffect, useState } from 'react';
import { useMemo } from 'react';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { Section } from 'foundations-components/transitional/components/Section';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { Subheader } from 'foundations-components/transitional/components/Header';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_PAGE = 1;
const PER_PAGE = 12;
const PaginatedUICardGrid = _ref => {
  let {
      children,
      onCalculateContents,
      onPageChange,
      title,
      totalCount,
      isLoadingPageOnDemand,
      page,
      limit = PER_PAGE
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [currentPage, setPage] = useState(page || DEFAULT_PAGE);
  const childrenLength = totalCount || Children.count(children);
  const sliceStart = (currentPage - 1) * limit;
  const sliceEnd = currentPage * limit;
  const childrenToRender = useMemo(() => {
    if (isLoadingPageOnDemand) {
      return children;
    } else {
      return children.slice(sliceStart, sliceEnd);
    }
  }, [children, isLoadingPageOnDemand, sliceEnd, sliceStart]);
  const changePage = value => {
    setPage(value);
    if (onPageChange) {
      onPageChange(value);
    }
  };
  useEffect(() => {
    if (onCalculateContents) {
      onCalculateContents({
        startCard: sliceStart + 1,
        endCard: sliceStart + childrenToRender.length,
        cardsTotal: childrenLength
      });
    }
  }, [onCalculateContents, childrenLength, sliceStart, childrenToRender.length]);
  if (sliceStart > childrenLength) {
    changePage(1);
    return null;
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!!title && /*#__PURE__*/_jsx(Subheader, {
      paddingBlockStart: "500",
      title: title
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(CardGrid, Object.assign({
        gridTemplateColumns: "repeat(auto-fill, minmax(298px, 1fr))"
      }, rest, {
        children: childrenToRender
      }))
    }), childrenLength > limit && /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Paginator, {
        defaultPage: currentPage,
        onPageChange: evt => changePage(evt.target.value),
        pageCount: Math.ceil(childrenLength / limit),
        showFirstLastButtons: true
      })
    })]
  });
};
export default PaginatedUICardGrid;